import { type MouseEventHandler, useEffect, useRef } from 'react';
import { Grid, MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import { LANGUAGES, useMyIntl } from 'my-intl';

import { styles } from './constants';
import { useScrollableLink } from '../hooks/use-scrollable-link';

import './menu.scss';

import BUL from '../images/BUL.gif';
import ENG from '../images/ENG.gif';
import RUS from '../images/RUS.gif';

interface MenuProps {
  customClass?: string;
  hasLang?: boolean;
  offset?: object;
  scrollOffset?: number;
  size?: number | object;
  onClick: (link: string) => void & MouseEventHandler<HTMLButtonElement>;
}

function Menu(props: MenuProps) {
  const { lang, translateMessage, changeLang } = useMyIntl();
  const firstRender = useRef<boolean>(true);

  const renderLink = (link: string, isActive?: boolean) =>
    getScrollableLink(translateMessage(`menu.${link}`), link, props.onClick, props.scrollOffset, '', isActive);

  const handleLangChange = (e: SelectChangeEvent<string>) => {
    changeLang(e.target.value);
  };

  const { get: getScrollableLink } = useScrollableLink();

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    }
  }, []);

  return (
    <Grid className={props.customClass} size={props.size} offset={props.offset}>
      {renderLink(styles.ids.about, firstRender.current)}
      {renderLink(styles.ids.bsic)}
      {renderLink(styles.ids.camps)}
      {renderLink(styles.ids.team)}
      {renderLink(styles.ids.contacts)}
      {props.hasLang && (
        <Select
          id={styles.ids.lang}
          MenuProps={{
            disableScrollLock: true,
          }}
          value={lang}
          onChange={handleLangChange}
        >
          <MenuItem value={LANGUAGES.BG}>
            <img src={BUL} alt="BUL"></img>
            &nbsp; Бг
          </MenuItem>
          <MenuItem value={LANGUAGES.EN}>
            <img src={ENG} alt="ENG"></img>
            &nbsp; En
          </MenuItem>
          <MenuItem value={LANGUAGES.RU}>
            <img src={RUS} alt="RUS"></img>
            &nbsp; Ру
          </MenuItem>
        </Select>
      )}
    </Grid>
  );
}

export default Menu;
